import { defineComponent as _defineComponent } from 'vue'
import { computed, inject, ref, Ref } from 'vue';
import { useRouter } from 'vue-router/composables';

import {
  NavBar,
  HeadingDisplay,
  Row,
  StatusMessage,
  ToggleSwitch,
  ButtonBoxIcon,
  ButtonContainer,
  ButtonPrimary,
  ButtonSecondary
} from '@warrenbrasil/nebraska-web';
import {
  BackButton,
  ShowMoneyToggleButton
} from '@/modules/common/components/buttons';
import { DeallocateLimitsModal } from './components/DeallocateLimitsModal';
import { ConfirmEditModal } from './components/ConfirmEditModal';

import { IMarginAllocation } from '@/modules/trade/services/margin-allocation';
import { EMarginAllocationSteps } from '@/modules/trade/views/MarginAllocation/helpers';
import { Money } from '@/modules/common/components/Money';


export default /*#__PURE__*/_defineComponent({
  __name: 'DayTrade',
  setup(__props) {

const router = useRouter();
const changeStep = inject('changeStep', (step: EMarginAllocationSteps) => ({
  step
}));
const fetchUpdatePreference = inject(
  'fetchUpdatePreference',
  (value: boolean) => ({ value })
);
const marginAllocation = inject('marginAllocation') as Ref<IMarginAllocation>;
const dataForm = inject('dataForm') as Ref<{ isUpdatingPreferences: boolean }>;

const savePreference = ref(marginAllocation.value.isPreferencesSaved);
const isConfirmEditModalOpen = ref(false);
const isDealocateModalOpen = ref(false);
const confirmEditModalStep = ref(EMarginAllocationSteps.BALANCE);

const isTraderShieldEnabled = computed(() => {
  return marginAllocation.value.isTraderShieldEnabled;
});

const disableEditWithTraderShield = computed(() => {
  return (
    marginAllocation.value.allocationChangeCount > 0 &&
    isTraderShieldEnabled.value
  );
});

const canEditLimits = computed(() => {
  return (
    !disableEditWithTraderShield.value && marginAllocation.value.canEditMargin
  );
});

const canDeallocateLimits = computed(() => {
  return (
    marginAllocation.value.balance.value > 0 &&
    !disableEditWithTraderShield.value
  );
});

function openDeallocateModal() {
  isDealocateModalOpen.value = true;
}

const hasPosition = computed(() => {
  return marginAllocation.value.hasPosition;
});

const details = computed(() => {
  return [
    {
      title: 'Saldo alocado',
      subtitle: marginAllocation.value.balance.formatted,
      step: EMarginAllocationSteps.BALANCE
    },
    {
      title: 'Prejuízo máximo',
      subtitle: marginAllocation.value.maximumDrawdown.formatted,
      step: EMarginAllocationSteps.DRAWDOWN
    }
  ];
});

const tradeShieldDetails = computed(() => {
  return isTraderShieldEnabled.value
    ? {
        title: 'Trader Shield ativo',
        description:
          'Para editar seus limites novamente, desative este recurso.',
        type: 'positive'
      }
    : {
        title: 'Ative o Trader Shield',
        description: 'Camada extra de proteção às suas operações',
        type: 'negative'
      };
});

const confirmEditModalData = computed(() => {
  return {
    updatedAt: marginAllocation.value.updatedAt,
    dayTradeBalance: marginAllocation.value.balance.formatted,
    variation: marginAllocation.value.variation
  };
});

function goToTraderShield() {
  changeStep(EMarginAllocationSteps.TRADER_SHIELD);
}

function editLimits() {
  if (marginAllocation.value.allocationChangeCount > 0) {
    isConfirmEditModalOpen.value = true;
    confirmEditModalStep.value = EMarginAllocationSteps.BALANCE;

    return;
  }
  changeStep(EMarginAllocationSteps.BALANCE);
}

function handlePreference() {
  fetchUpdatePreference(savePreference.value);
}

function handleBack() {
  router.push({ name: 'trade' });
}

return { __sfc: true,router, changeStep, fetchUpdatePreference, marginAllocation, dataForm, savePreference, isConfirmEditModalOpen, isDealocateModalOpen, confirmEditModalStep, isTraderShieldEnabled, disableEditWithTraderShield, canEditLimits, canDeallocateLimits, openDeallocateModal, hasPosition, details, tradeShieldDetails, confirmEditModalData, goToTraderShield, editLimits, handlePreference, handleBack, NavBar, HeadingDisplay, Row, StatusMessage, ToggleSwitch, ButtonBoxIcon, ButtonContainer, ButtonPrimary, ButtonSecondary, BackButton, ShowMoneyToggleButton, DeallocateLimitsModal, ConfirmEditModal, Money }
}

})